import EmblaCarousel from 'embla-carousel';

(function () {
  // Evita rodar no editor/admin
  if (typeof document !== 'undefined') {
    const b = document.body;
    if (b && (b.classList.contains('block-editor-page') || b.classList.contains('wp-admin'))) {
      return;
    }
  }

  const q = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function init(root) {
    if (!root || root.__cvEmbla) return; // evita duplo init

    const viewport = root.querySelector('.cv-carousel__viewport');
    const container = root.querySelector('.cv-carousel__container');
    if (!viewport || !container) return;

    const prevBtn = root.querySelector('.cv-carousel__arrow--prev');
    const nextBtn = root.querySelector('.cv-carousel__arrow--next');
    const dotsWrap = root.querySelector('.cv-carousel__dots');

    const loop = root.dataset.loop === '1';
    const autoplay = root.dataset.autoplay === '1';
    const dotsEnabled = root.dataset.dots === '1';
    const timeout = Math.max(1000, parseInt(root.dataset.timeout || '4000', 10));

    const embla = EmblaCarousel(viewport, {
      loop,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: 1,
      dragFree: false,
    });
    root.__cvEmbla = embla;

    // ---------- DOTS ----------
    let dotsButtons = [];
    function buildDots() {
      if (!dotsEnabled || !dotsWrap) return;
      const count = embla.scrollSnapList().length;
      dotsWrap.innerHTML = '';
      dotsButtons = [];
      for (let i = 0; i < count; i++) {
        const b = document.createElement('button');
        b.className = 'cv-carousel__dot';
        b.type = 'button';
        b.ariaLabel = `Ir para slide ${i + 1}`;
        b.addEventListener('click', () => embla.scrollTo(i));
        dotsWrap.appendChild(b);
        dotsButtons.push(b);
      }
      setActiveDot(embla.selectedScrollSnap());
    }
    function setActiveDot(idx) {
      if (!dotsEnabled || !dotsWrap) return;
      dotsButtons.forEach((b, i) => b.classList.toggle('is-active', i === idx));
    }

    // ---------- AUTOPLAY ----------
    let timer = null;
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(() => embla && embla.scrollNext(), timeout);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Pausar autoplay durante interação/hover
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // ---------- ARROWS ----------
    function setArrowsState() {
      if (!prevBtn || !nextBtn) return;
      if (loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
      } else {
        prevBtn.disabled = !embla.canScrollPrev();
        nextBtn.disabled = !embla.canScrollNext();
      }
    }

    function bindArrows() {
      if (prevBtn) {
        prevBtn.addEventListener('click', onPrevClick);
        prevBtn.addEventListener('pointerdown', stopAutoplay);
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', onNextClick);
        nextBtn.addEventListener('pointerdown', stopAutoplay);
      }
    }
    function unbindArrows() {
      if (prevBtn) {
        prevBtn.removeEventListener('click', onPrevClick);
        prevBtn.removeEventListener('pointerdown', stopAutoplay);
      }
      if (nextBtn) {
        nextBtn.removeEventListener('click', onNextClick);
        nextBtn.removeEventListener('pointerdown', stopAutoplay);
      }
    }
    function onPrevClick(e) {
      e.preventDefault();
      embla && embla.scrollPrev();
    }
    function onNextClick(e) {
      e.preventDefault();
      embla && embla.scrollNext();
    }

    // ---------- BINDINGS DO EMBLA ----------
    embla.on('select', () => {
      setActiveDot(embla.selectedScrollSnap());
      setArrowsState();
    });
    embla.on('reInit', () => {
      buildDots();
      setActiveDot(embla.selectedScrollSnap());
      setArrowsState();
    });
    embla.on('init', () => {
      buildDots();
      setActiveDot(embla.selectedScrollSnap());
      setArrowsState();
    });

    embla.on('pointerDown', stopAutoplay);
    embla.on('pointerUp', startAutoplay);
    embla.on('destroy', () => {
      stopAutoplay();
      unbindArrows();
    });

    // Kick-off
    bindArrows();
    buildDots();
    setArrowsState();
    startAutoplay();
  }

  function boot() {
    q('.cv-carousel').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
